let moment, insertAtCursor, angular, EscapeHtml, Switchery;
import Translator from "utils/translator";
import showFlash from "flash-message";

module.exports = Promise.all([
    import("tap-moment"),
    import("utils/insert-at-cursor"),
    import("angular"),
    import("utils/escape-html"),
    import("switchery-npm"),
    import("tap-charts"),
    import("selectize"),
    import("bootstrap/js/tooltip"),
])
    .then(deps => {
        [moment, insertAtCursor, angular, EscapeHtml, Switchery] = deps;
        moment = moment.default;
        Switchery = Switchery.default;
        insertAtCursor = insertAtCursor.default;
        EscapeHtml = EscapeHtml.default;

        return import("angular-sanitize");
    })
    .then(() => {
        var app = angular.module("tapDirectives", ["ngSanitize"]);

        app.directive("tapChart", function($timeout) {
            return {
                restrict: "E",
                controller: function($scope) {
                    $scope.graphSelected = function(graph) {
                        $scope.selectedGraph = graph;
                        $scope.drawChart();
                    };

                    $scope.drawChart = function() {
                        var data = $scope.graphData;

                        $scope.chartTypeDropdown = $scope.graphData.columns.reduce(
                            (carry, column) => {
                                carry.items.push({
                                    title: Translator.trans(column.name),
                                    action: () => {
                                        $scope.graphSelected(column);
                                    },
                                });

                                return carry;
                            },
                            {
                                items: [],
                                emptyContent: "{{ selected }}",
                            },
                        );

                        let opts = {
                            type: "serial",
                            language: Translator.locale,
                            pathToImages: "/bundles/tapsite/js/amcharts/images/",
                            dataProvider: data.results,
                            marginTop: 10,
                            marginLeft: 0,
                            categoryField: "title",
                            dataDateFormat: "YYYY-MM-DD",
                            dateFormat: "MMM. D, YYYY",
                            hideCredits: true,
                            categoryAxis: {
                                gridAlpha: 0.07,
                                axisColor: "#DADADA",
                                parseDates: data.dateChart,
                                equalSpacing: true,
                                startOnAxis: true,
                            },
                            valueAxis: {
                                gridAlpha: 0.07,
                                integersOnly: true,
                            },
                            chartCursor: {
                                cursorAlpha: 0.6,
                                cursorColor: "#aaa",
                            },
                        };

                        let graph = {
                            balloonFunction: function(item) {
                                const label = data.dateChart
                                    ? moment(item.category).format(opts.dateFormat)
                                    : item.category;

                                let balloonText = `
                            <span style='font-size:14px; color:#000000;'>${label} |
                                ${Translator.trans($scope.selectedGraph.name)}
                                <b>${Math.round(item.values.value, 2)}</b>
                            </span>`;

                                return balloonText;
                            },
                            valueField: $scope.selectedGraph.property,
                            lineAlpha: 1,
                            lineThickness: 2.5,
                            fillAlphas: 0,
                            fillColors: "#76b2bf",
                            lineColor: "#51a1f2",
                        };

                        switch (data.type) {
                            case "bar":
                                opts.categoryAxis.labelRotation = 45;
                                graph.type = "column";
                                break;

                            default:
                                graph.type = "line";
                                graph.bullet = "none";
                                graph.bulletBorderColor = "#FFFFFF";
                                graph.bulletBorderAlpha = 1;
                                break;
                        }

                        opts.graphs = [graph];
                        AmCharts.makeChart($scope.chartId, opts);
                    };
                },
                link: function(scope, elm, attrs) {
                    scope.chartId = "chart_" + new Date().getTime();
                    var height = attrs.chartHeight;
                    elm.find(".chart-holder")
                        .attr("id", scope.chartId)
                        .css("height", height);

                    attrs.$observe("getChartdataMethod", function(getChartdataMethod) {
                        if (!getChartdataMethod) return;
                        scope.$watch(
                            function() {
                                return scope[getChartdataMethod]();
                            },
                            function(newValue) {
                                if (newValue === null) scope.selectedGraph = null;
                                if (!newValue) return;
                                if (!scope.selectedGraph) scope.selectedGraph = newValue.columns[0];

                                scope.graphData = newValue;

                                $timeout(function() {
                                    scope.drawChart();
                                });
                            },
                        );
                    });
                },
                template:
                    '<tap-dropdown data="chartTypeDropdown" initial-selected="chartTypeDropdown.items[0]" name="chartTypeDropdown" class="spaced-2"></tap-dropdown><div class="chart-holder"></div>',
            };
        });

        app.directive("confirmClick", function($window) {
            var showModal = require("tap-modal/tap-modal");
            var i = 0;
            return {
                restrict: "A",
                priority: 1,
                compile: function(tElem, tAttrs) {
                    var fn = "$$confirmClick" + i++,
                        _ngClick = tAttrs.ngClick;
                    tAttrs.ngClick = fn + "($event)";

                    return function(scope, elem, attrs) {
                        var confirmTitle = attrs.confirmTitle || "Are you sure?";
                        var confirmMsg = attrs.confirmClick || "Are you sure you want to proceed?";
                        var confirmButtonClass = attrs.confirmButtonClass || "btn-danger";

                        scope[fn] = function(event) {
                            showModal(confirmTitle, confirmMsg, null, [
                                {
                                    classes: `btn ${confirmButtonClass}`,
                                    callback: function() {
                                        scope.$eval(_ngClick, { $event: event });
                                        scope.$apply();
                                    },
                                },
                                {
                                    text: "Cancel",
                                },
                            ]);
                        };
                    };
                },
            };
        });

        app.directive("editable", [
            "$filter",
            "$sce",
            "$sanitize",
            "$compile",
            function($filter, $sce, $sanitize, $compile) {
                var self = this;
                return {
                    restrict: "A",
                    priority: 1,
                    scope: {
                        editable: "=editable",
                        editableIf: "=editableIf",
                        editableTags: "=editableTags",
                        editableOnSave: "=editableOnSave",
                        editableProperty: "@editableProperty",
                        editableFieldType: "=editableFieldType",
                        editableFieldSize: "=editableFieldSize",
                        editableIconClasses: "=editableIconClasses",
                        editableDisplayFilter: "=editableDisplayFilter",
                        editableDisplayFilterVars: "=editableDisplayFilterVars",
                        editableDiplayValueIsTrusted: "=editableDiplayValueIsTrusted",
                        editableFieldDirectives: "@editableFieldDirectives",
                        editableInputClasses: "@editableInputClasses",
                        editableConfirmationText: "@editableConfirmationText",
                        editableValid: "=editableValid",
                    },
                    template: function(el, attr) {
                        return `<span ng-if="editing"> <div class="input-inline-edit input-inline-edit-{{ inputSize }}" ng-class="{'input-group': editableTags, 'di': !editableTags}">
                <input type="text" ng-model="newVal" class="form-control {{ editableInputClasses }} input-{{ inputSize }} input-inline-edit f-l" ng-class="{'spaced-right-small': !editableTags}" ng-show="editableFieldType != 'textarea'"
                    uib-tooltip="${attr.editableConfirmationText ? attr.editableConfirmationText : ""}"
                    ${attr.editableFieldDirectives ? attr.editableFieldDirectives : ""}
                />
                <textarea ng-model="newVal" class="form-control {{ editableInputClasses }} f-l" ng-class="{'spaced-super-small': !editableTags}" ng-show="editableFieldType == 'textarea'"></textarea>
                <span class=input-group-addon ng-show="editableTags"> <div class="dropdown"><a class="dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown">Tags <span class="caret"></span></a> <ul class="dropdown-menu grouped-list pull-right t-left" role="menu"> <li role="presentation" ng-repeat="(tagGroupName, tagGroup) in editableTags" class="no-hover-state"><span class="grouped-list-title">{{ tagGroupName|trans|capitalize }}</span> <ul role="menu"> <li role="presentation" ng-repeat="tagKey in tagGroup" class="no-hover-state"><a class="clickable bold td-none" ng-click="appendTag($event, (tagGroupName + '.' + tagKey))">{{ ("object.properties." + tagKey)|trans|capitalize }}</a></li> </ul> </li> </ul> </div> </div>
                <a class="clickable btn btn-default btn-xs f-l spaced-right-tiny" ng-click="cancelEdit()">Cancel</a><a class="clickable btn btn-success btn-xs f-l spaced-right-small"
                ${attr.editableValid ? ' ng-disabled="!editableValid(newVal)"' : " "}
                ng-click="saveEdit(newVal)">Save</a></span>
                <span ng-if="!editing"><span ng-if="editableDiplayValueIsTrusted" ng-bind-html="dispVal"></span><span ng-if="!editableDiplayValueIsTrusted">{{ dispVal }}</span> <span class="tapicon tapicon-edit {{ editableIconClasses }}" ng-class="(editableFieldType != 'textarea') ? 'spaced-inline-left-small' : ''" ng-click="startEdit()" ng-class="editableIf ? 'clickable' : 'disabled' " ng-disabled="!editableIf"></span></span><span class="help-block regular-fs danger" ng-if="errors">{{ errors }}</span`;
                    },
                    link: function(scope, el, attr) {
                        scope.inputSize = attr.editableFieldSize || "sm";
                    },
                    controller: function($scope, $element) {
                        function escapeHtml(html) {
                            return $sanitize(html);
                            // var div = document.createElement('div');
                            // div.innerText = text;
                            // return div.innerHTML;
                        }

                        $scope.startEdit = function() {
                            if (!$scope.editableIf) return;
                            if (angular.isArray($scope.curVal)) $scope.isArray = true;
                            $scope.newVal = $scope.curVal;
                            $scope.editing = true;
                        };

                        $scope.cancelEdit = function() {
                            $scope.errors = null;
                            $scope.editing = false;
                        };

                        $scope.saveEdit = function(val) {
                            if ($scope.editableValid && !$scope.editableValid(val)) return;

                            $scope.errors = null;
                            $scope.editing = false;
                            $scope.orgVal = $scope.curVal;

                            if (val && $scope.isArray && !angular.isArray(val)) val = val.split(",");

                            $scope.curVal = val;
                            $scope.editable[$scope.editableProperty] = val;
                            var dispVal = $scope.editableDisplayFilter
                                ? $filter($scope.editableDisplayFilter).apply(
                                      this,
                                      [$scope.editable[$scope.editableProperty]].concat(
                                          $scope.editableDisplayFilterVars,
                                      ),
                                  )
                                : $scope.editable[$scope.editableProperty];

                            $scope.dispVal = $scope.editableDiplayValueIsTrusted
                                ? $sce.trustAsHtml(dispVal || "-")
                                : $sanitize(dispVal) || "-";

                            if (typeof $scope.editableOnSave === "function")
                                $scope.editableOnSave($scope.editable, function(err) {
                                    if (!err) return;
                                    $scope.editing = true;
                                    $scope.errors = err[0];
                                    $scope.newVal = val;
                                    $scope.curVal = $scope.orgVal;
                                    $scope.editable[$scope.editableProperty] = $scope.orgVal;
                                });
                        };

                        $scope.appendTag = function($event, key) {
                            var el = angular
                                .element($event.target)
                                .parents(".input-group")
                                .find("input, textarea");
                            insertAtCursor(el[0], "${" + key + "}");
                            el.trigger("input");
                        };

                        $scope.$watch("editableIf", function(newValue) {
                            if (newValue === false) $scope.cancelEdit();
                        });

                        $scope.$watch(
                            "editable",
                            function(newValue) {
                                if (!newValue) return;

                                $scope.curVal = $scope.editable[$scope.editableProperty];
                                var dispVal = $scope.editableDisplayFilter
                                    ? $filter($scope.editableDisplayFilter).apply(
                                          this,
                                          [$scope.editable[$scope.editableProperty]].concat(
                                              $scope.editableDisplayFilterVars,
                                          ),
                                      )
                                    : $scope.editable[$scope.editableProperty];
                                $scope.dispVal = $sce.trustAsHtml(escapeHtml(dispVal) || "-");
                                $scope.dispVal = dispVal;
                            },
                            true,
                        );
                    },
                };
            },
        ]);

        app.directive("tapDropdown", function() {
            return {
                restrict: "E",
                replace: true,
                scope: {
                    data: "=",
                    el: "@",
                    type: "@",
                    dropdownClasses: "@",
                    initialSelected: "=",
                },
                link: function(scope, el) {
                    scope.element = el[0];
                },
                template: function(el, attr) {
                    var template =
                        '<div class="dropdown" ng-click="toggle()" ng-class="{\'open\': dropDownOpen}"><a class="c-filter-block dropdown-toggle"><div bind-html-compile="emptyContentTrusted" class="spaced-inline-right-small"></div> <span class="caret"></span></a>';
                    if (attr.type === "content") {
                        template +=
                            '<div class="dropdown-menu {{ dropdownClasses }}" bind-html-compile="data.content"></div>';
                    } else {
                        template +=
                            '<ul class="dropdown-menu t-left {{ dropdownClasses }}" role="menu"><li role="presentation" ng-repeat="item in data.items"><a class="clickable bold td-none" ng-click="itemClicked(item)">{{ item.title }}</a></li></ul>';
                    }

                    template += "</div>";

                    return template;
                },
                controller: [
                    "$scope",
                    "$sce",
                    function($scope, $sce) {
                        let initialFirstSelected = false;
                        $scope.$watch(
                            "data",
                            function(data) {
                                if (!data) return;

                                $scope.emptyContentTrusted = $sce.trustAsHtml($scope.data.emptyContent);

                                if ($scope.initialSelected && !initialFirstSelected) {
                                    $scope.selected = $scope.initialSelected.title;
                                    initialFirstSelected = true;
                                }
                            },
                            true,
                        );

                        $scope.itemClicked = function(item) {
                            if (typeof item.array === "string") {
                                item.array = item.array.length !== 0 ? item.array.split(",") : null;
                                $scope.selected = item.array;
                            } else {
                                $scope.selected = item.title;
                            }

                            $scope.$emit("tapDropdownItemClicked", { name: name, data: item });
                        };

                        $scope.dropDownOpen = false;

                        $(document).on("click", function(ev) {
                            if (ev.target == $scope.element || $.contains($scope.element, ev.target)) return;
                            $scope.dropDownOpen = false;
                            $scope.$apply();
                        });

                        $(document).on("keyup", function(e) {
                            if (e.which == 27) {
                                $scope.dropDownOpen = false;
                                $scope.$apply();
                            }
                        });

                        $scope.toggle = function() {
                            $scope.dropDownOpen = !$scope.dropDownOpen;
                        };
                    },
                ],
            };
        });

        app.directive("bindHtmlCompile", [
            "$compile",
            function($compile) {
                return {
                    restrict: "A",
                    link: function(scope, element, attrs) {
                        scope.$watch(
                            function() {
                                return scope.$eval(attrs.bindHtmlCompile);
                            },
                            function(value) {
                                element.html(value && value.toString());
                                var compileScope = scope;
                                if (attrs.bindHtmlScope) compileScope = scope.$eval(attrs.bindHtmlScope);
                                $compile(element.contents())(compileScope);
                            },
                        );
                    },
                };
            },
        ]);

        app.directive("selectize", function() {
            return {
                restrict: "A",
                scope: {
                    selectizeOnAdd: "=",
                    selectizeOnRemove: "=",
                    selectizePlaceholder: "=",
                    ngModel: "=",
                },
                link: function(scope, element, attrs) {
                    var placeholder = scope.selectizePlaceholder || "Type to add..";
                    var options = {
                        delimiter: ",",
                        persist: false,
                        plugins: ["remove_button"],
                        placeholder: placeholder,
                        create: function(input) {
                            return {
                                value: input.toLowerCase(),
                                text: input.toLowerCase(),
                            };
                        },
                    };

                    $(element).val(scope.ngModel);
                    $(element).selectize(options);
                },
            };
        });

        app.directive("mergeTags", [
            "$compile",
            function($compile) {
                return {
                    restrict: "A",
                    scope: {
                        mergeTags: "=",
                    },
                    transclude: true,
                    replace: true,
                    template: '<div class="input-group" ng-transclude>',
                    link: function(scope, el, attr) {
                        $(el).append(
                            $compile(`
                        <span class=input-group-addon ng-show="mergeTags">
                            <div class="dropdown">
                                <a class="dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown">Tags <span class="tapicon tapicon-info tap-popover subtle" tap-popover data-title="Tags" data-content="Tags are used in combination with UTM parameters, which allow you to send data about your campaigns to analytics services like Google Analytics."></span> <span class="caret"></span>
                                </a>
                                <ul class="dropdown-menu grouped-list pull-right t-left" role="menu">
                                    <li role="presentation" ng-repeat="(tagGroupName, tagGroup) in mergeTags">
                                        <span class="grouped-list-title">{{ tagGroupName|trans|capitalize }}</span>
                                        <ul role="menu">
                                            <li role="presentation" ng-repeat="tagKey in tagGroup">
                                                <a class="clickable bold td-none" ng-click="appendTag($event, (tagGroupName + \'.\' + tagKey))">{{ tagKey|trans|capitalize }}</a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </span>`)(scope),
                        );
                    },
                    controller: function($scope) {
                        $scope.appendTag = function($event, key) {
                            var el = angular
                                .element($event.target)
                                .parents(".input-group")
                                .find("input, textarea");
                            insertAtCursor(el[0], "${" + key + "}");
                            el.trigger("input");
                        };
                    },
                };
            },
        ]);

        app.directive("keysValuesInput", [
            function() {
                return {
                    restrict: "E",
                    scope: {
                        pairs: "=",
                        disabled: "=",
                    },
                    template: `<div class="row spaced" ng-repeat="pair in _pairs">
                            <div class="col-xs-1">{{ $index + 1 }}.</div>
                            <div class="col-xs-4"><input type="text" ng-model="pair.key" class="form-control input-sm" placeholder="Key" ng-disabled="disabled" ></div>
                            <div class="col-xs-5"><input type="text" ng-model="pair.value" class="form-control input-sm" placeholder="Value" ng-disabled="disabled" ></div>
                            <div class="col-xs-1"><span class="tapicon tapicon-delete smaller tapicon-danger clickable" ng-click="removePair($event, $index)"></span></div>
                        </div>
                        <button class="btn btn-sm btn-default" type="button" ng-click="addPair()" ng-disabled="disabled"><span class="tapicon tapicon-add"></span> add<span ng-show="pair_s.length > 0"> more</span></button>`,
                    controller: function($scope) {
                        $scope._pairs = [];
                        $scope.pairs = typeof $scope.pairs === "object" ? $scope.pairs : {};

                        for (var key in $scope.pairs) {
                            $scope.addPair(key, $scope.pairs[key]);
                        }

                        $scope.addPair = function(key = null, value = null) {
                            if ($scope._pairs.length >= 10)
                                return showFlash("warning", "Maximum allowed number of meta data properties is 10");

                            $scope._pairs.push({
                                key: key,
                                value: value,
                            });
                        };

                        $scope.removePair = function($event, i) {
                            $event.stopPropagation();
                            $scope._pairs.splice(i, 1);
                        };

                        $scope.$watch(
                            "_pairs",
                            function(newPairs) {
                                $scope.pairs = newPairs.reduce((a, b) => {
                                    a[b["key"]] = b["value"];
                                    return a;
                                }, {});
                            },
                            true,
                        );

                        $scope.$watch("pairs", function(newPairs, oldPairs) {
                            if (Object.keys(newPairs).length === 0 && Object.keys(oldPairs).length !== 0)
                                $scope._pairs = [];
                        });
                    },
                };
            },
        ]);

        app.directive("tapToggle", [
            function() {
                return {
                    restrict: "A",
                    scope: {
                        ngModel: "=",
                        ngChange: "=",
                        watch: "=",
                    },
                    controller: [
                        "$scope",
                        "$element",
                        function($scope, $element) {
                            var switcher;
                            $scope.$watch("watch", function(item) {
                                if (switcher) {
                                    angular.element(switcher.switcher).remove();
                                }

                                switcher = new Switchery($element[0], {
                                    color: "#76b2bf",
                                    secondaryColor: "#ebebeb",
                                    size: "small",
                                });

                                $element[0].addEventListener("change", function(evt) {
                                    $scope.$apply(function() {
                                        $scope.ngModel = $element[0].checked;
                                    });
                                });
                            });
                        },
                    ],
                };
            },
        ]);

        app.directive("tapSearch", [
            function() {
                return {
                    restrict: "A",
                    scope: {
                        tapSearchKey: "@",
                        tapSearchModel: "=",
                        tapSearchSelectedItem: "=",
                    },
                    controller: [
                        "$scope",
                        "$element",
                        function($scope, $element) {
                            Promise.all([import("tap-search/tap-search"), import("tap-search/search-callbacks")]).then(
                                deps => {
                                    let [SP, searchCallbacks] = deps;
                                    SP.default.then(() => {
                                        $element.tapSearch({
                                            dropdown: true,
                                            target: ".suggestions-holder",
                                            preAppendItem: function($item, hit) {
                                                $item.append(`<div class="search-suggestion clickable">
                                                <div class="search-suggestion-title"><a href="#">${EscapeHtml(
                                                    hit.firstname + " " + hit.lastname,
                                                )}</a></div>
                                              </div>`);
                                            },
                                            preAppendNoResultsItem: searchCallbacks.preAppendNoResultsItem,
                                            postPickItem: function(hit) {
                                                $scope.tapSearchSelectedItem = `${hit.firstname} ${hit.lastname}`;
                                                $scope.tapSearchModel = hit.id;
                                                $scope.$apply();
                                            },
                                        });
                                    });
                                },
                            );
                        },
                    ],
                };
            },
        ]);
    });
